// example:
//
// this.savedEditCollection = {
//     47951504: [
//        { entryLine: 'xe9', oldQuantity: 1, newQuantity: 2 },
//        { entryLine: '8ki', oldQuantity: 1, newQuantity: 0 }
//     ]
// }

KMVP.kmcQuoteEditStorage = {
    savedEditCollection: {},
    getCurrentQuoteEditChanges: function() {
        var quoteId = KMVP.kmcQuoteEditTemplating.getCurrentQuoteId();
        return this.savedEditCollection[quoteId];
    },
    saveChange: function(quoteId, entryLine, oldQuantity, newQuantity) {
        var entryEditRecord = {
            entryLine: entryLine,
            oldQuantity: oldQuantity,
            newQuantity: newQuantity
        }
        if (oldQuantity !== newQuantity) {
            this.addNewEntryEditRecord(quoteId, entryEditRecord)
        } else {
            this.removeEntryEditRecord(quoteId, entryLine)
        }
        KMVP.kmcQuoteEditTemplating.applyRowChanges(quoteId, entryEditRecord);
    },
    initialCheck: function() {
        this.savedEditCollection = this.getFromLocalStorage();
        var quoteId = KMVP.kmcQuoteEditTemplating.getCurrentQuoteId();
        var quoteEditData = this.savedEditCollection[quoteId];
        if (quoteEditData) {
            KMVP.kmcQuoteEditTemplating.applyTemplateChanges(quoteId, quoteEditData);
            KMVP.kmcQuoteEditTemplating.applyQuotePageChanges(quoteEditData);
        }
    },
    addNewEntryEditRecord: function(quoteId, entryEditRecord) {
        var quoteEditData = this.savedEditCollection[quoteId] || [];
        var entryEditRecords = quoteEditData.filter(function(entry) {
            return entry.entryLine !== entryEditRecord.entryLine;
        });
        entryEditRecords.push(entryEditRecord);
        this.savedEditCollection[quoteId] = entryEditRecords;
        this.setInLocalStorage(this.savedEditCollection);
        KMVP.kmcQuoteEditTemplating.applyQuotePageChanges(entryEditRecords);
    },
    removeEntryEditRecord: function(quoteId, entryLine) {
        var quoteEditData = this.savedEditCollection[quoteId];
        this.savedEditCollection[quoteId] = quoteEditData.filter(function(entry) {
            return entry.entryLine !== entryLine;
        });
        this.setInLocalStorage(this.savedEditCollection);
        this.removeQuoteDataIfEmpty(quoteId);
        KMVP.kmcQuoteEditTemplating.applyQuotePageChanges(this.savedEditCollection[quoteId]);
    },
    deleteQuoteEntry: function(quoteId, entryLine, oldQuantity) {
        this.saveChange(quoteId, entryLine, oldQuantity, 0);
    },
    undoEditChanges: function(quoteId, entryLine) {
        var quoteEditData = this.savedEditCollection[quoteId];
        var entryEditRecord = quoteEditData.filter(function(entry) {
            return entry.entryLine === entryLine;
        });
        var oldQuantity = entryEditRecord[0].oldQuantity;
        this.saveChange(quoteId, entryLine, oldQuantity, oldQuantity);
        this.removeQuoteDataIfEmpty(quoteId);
    },
    undoAllInQuote: function(quoteId) {
        var quoteEditData = this.savedEditCollection[quoteId] || [];
        quoteEditData.forEach(function(entry) {
            KMVP.kmcQuoteEditStorage.undoEditChanges(quoteId, entry.entryLine)
        });
    },
    removeQuoteDataIfEmpty: function(quoteId) {
        var quoteEditData = this.savedEditCollection[quoteId];
        if (quoteEditData && !quoteEditData.length) {
            delete this.savedEditCollection[quoteId];
            this.setInLocalStorage(this.savedEditCollection);
        }
    },
    setInLocalStorage: function(data) {
        localStorage.setItem('quoteEdit', JSON.stringify(data));
    },
    getFromLocalStorage: function() {
        return JSON.parse(localStorage.getItem('quoteEdit')) || {};
    }
};

$(document).ready(function() {
    if ($('.js-kmc-quote-detail-page.js-kmc-quote-status-quote').length) {
        window.onload = function() {
            KMVP.kmcQuoteEditStorage.initialCheck();
        };
    }
});
